import { Component, ElementRef, OnInit } from "@angular/core";
import { SharedAnimations } from "src/app/shared/animations/shared-animations";
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from "@angular/forms";
import { OpenService } from "@app-services/open.service";
import { LayoutVars } from "@app/store/session/session.store";
import { MarketPlacePersonalizationUtils } from "@app-components/layouts/shopkeeper-layout/marketplace-personalization";
import { DealerDetails, MaritalStatus } from "@app/views/private/admin/model/admin-models";
import { cnpjMask, cpfMask, dateMask, phoneMask } from "@app-utils/masks";
import { noop, Observable } from "rxjs";
import { cepMask, City } from "@app-model/city";
import { SegmentLabel } from "@app-model/product";
import { ToastrService } from "ngx-toastr";
import { ValidatorPhone } from "@app/views/private/admin/admin-common/util/admin-util-functions";
import { isCnpj, isCpf } from "validator-brazil";
import { ViaCep } from "@app-model/application";
import { ApplicationService } from "@app-services/application.service";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { IdName } from "@app-services/oem-dealer.service";
import * as moment from "moment";
import { environment } from "@env/environment";

@Component({
  selector: "app-create-dealer",
  templateUrl: "./create-dealer.component.html",
  styleUrls: ["./create-dealer.component.scss"],
  animations: [SharedAnimations]
})
export class CreateDealerComponent implements OnInit {
  layoutVars: LayoutVars;
  form: FormGroup;
  showError: boolean;
  errorCode: string;
  dealerDetails: DealerDetails = new DealerDetails();
  date: number= new Date().getFullYear();
  createdSuccessfuly: boolean;

  cpfmask = { mask: cpfMask };

  dateMask = { mask: dateMask };

  cnpjmask = { mask: cnpjMask };

  cityControl: FormControl = new FormControl("", {
    validators: [this.isRequiredAddress()],
    updateOn: "change",
  });
  cityOptions: Observable<City[]>;

  telephoneMask = { mask: phoneMask };

  cepMask = { mask: cepMask, guide: true };

  allSegments = SegmentLabel.allSegments;

  selectedCity: City;
  layoutVarsResponse: boolean;

  options: IdName[];

  public readonly termsOfUse = environment.docs.termsAndConditionsOfUse;
  public readonly privacyPolicy = environment.docs.privacyPolicy;

  constructor(
    private fb: FormBuilder,
    private openService: OpenService,
    private elRef: ElementRef,
    private toaster: ToastrService,
    private applicationService: ApplicationService
  ) {
    this.openService.getLayoutVars()
      .subscribe(result => {
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, this.layoutVars);
        this.layoutVars = result;
        this.layoutVarsResponse = true;
      });
  }

  ngOnInit() {
    this.initFormGroup();
    this.toggleSegment('AGRO');
    this.getOptions();
    this.cityControl.valueChanges.subscribe((val) =>
      this.onChangeCityQuery(val)
    );
  }

  initFormGroup(): void {
    this.form = this.fb.group({
      name: ["", { validators: [Validators.required] }],
      legalName: ["", { validators: [this.isRequiredFor('COMPANY')] }],
      cityRegistration: ["", { validators: [this.isRequiredFor('COMPANY')] }],
      stateRegistration: ["", { validators: [this.isRequiredFor('COMPANY')] }],
      maritalStatus: ["", { validators: [this.isRequiredFor('PERSON')] }],
      uf: ["", {}],
      email: ["", { validators: [Validators.required, Validators.email] }],
      city: this.cityControl,
      cpfCnpj: ["", {
        validators: [Validators.required, this.validatorCpfCnpj()],
        updatedOn: "blur"
      }],
      type: ["COMPANY", { validators: [Validators.required] }],
      zipCode: ["", { validators: [this.isRequiredAddress()] }],
      phoneNumber: ["", { validators: [ValidatorPhone, Validators.required] }],
      address: ["", { validators: [this.isRequiredAddress()] }],
      addressNumber: ["", { validators: [this.isRequiredAddress()] }],
      addressComplement: ["", {}],
      district: ["", { validators: [this.isRequiredAddress()] }],
      whatsappNumber: ["", {}],
      whatsappOptin: ["", {}],
      noReceiveOffers: ["", {}],
      birthDate: ["", {validators:[this.validatorBirthDate() , this.isRequiredBirthDate('PERSON')]}],
      acceptTermsOfUse: [false, {validators: [Validators.requiredTrue], updateOn: 'submit'}]
    });
  }


  isRequiredFor(typePerson: string): ValidatorFn {
    return (currentControl: AbstractControl): { [key: string]: any } => {
      if (this.form && this.form.value && this.form.value.type && this.form.value.type === typePerson) {
        return Validators.required(currentControl);
      }
      return null;
    };
  }

  isRequiredAddress(): ValidatorFn{
    return (currentControl: AbstractControl): {[key: string]: any} => {
      if(this.layoutVars && this.layoutVars.noAllowSensitiveData){
        return null
      }
      return Validators.required(currentControl);
    }
   }

   isRequiredBirthDate(typePerson: string): ValidatorFn{
    return (currentControl: AbstractControl): { [key: string]: any} => {
      if(this.isRequiredAddress == null){
        return this.isRequiredFor(typePerson);
      }else{
        return this.isRequiredAddress();
      }
    }
   }

  validatorBirthDate(): ValidatorFn {
    return (currentControl: AbstractControl): { [key: string]: any } => {
      let date = String(currentControl.value);
      if (this.clearValue(date).length == 0) {
        return null;
      }

      let dateSplit = date.split('/');

      if(dateSplit.length < 3){
        return {birthDateInvalid: true};
      }

      if(parseInt(dateSplit[0]) <= 0 || parseInt(dateSplit[0]) > 31){
        return {birthDateInvalid: true};
      }

      if(parseInt(dateSplit[1]) <= 0 || parseInt(dateSplit[1]) > 12){
        return {birthDateInvalid: true};
      }

      if(parseInt(dateSplit[2]) < (this.date - 100) || parseInt(dateSplit[2]) > (this.date - 18)) {
        return {birthDateInvalid: true};
      }
      return null;
    };
  }

  clearValue(a: string): string {
    return String(a).replace(/[^\w\s]/gi, "");
  }

  validatorCpfCnpj(): ValidatorFn {
    return (currentControl: AbstractControl): { [key: string]: any } => {
      let a = String(currentControl.value);
      if (this.clearValue(a).length == 0) {
        return null;
      }

      if (isCpf(a)) {
        return null;
      }
      if (isCnpj(a)) {
        return null;
      } else {
        return { cpfcpnjInvalid: true };
      }
    };
  }

  stringToNumber(a: any): number {
    a = String(a);
    let b = a
      .replace(/[&\/\\#,+()$~%.'":*?<>_{}]/g, "")
      .replace("-", "")
      .replace(/ /g, "")
      .replace(/\D/g, "");
    return parseInt(b, 10);
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: FormControl) => {
      control.markAsTouched();
    });
  }

  private getMaritalStatusKey(): string {
    if (this.form && this.form.value && this.form.value.maritalStatus) {
      let keys = Object.keys(MaritalStatus).filter(x => MaritalStatus[x] == this.form.value.maritalStatus);
      return keys.length > 0 ? keys[0] : null;
    }
    return undefined;
  }

  prepareDealerToSave(): DealerDetails {
    const dealer: DealerDetails = this.form.value as DealerDetails;

    if (this.selectedCity) {
      dealer.cityName = this.selectedCity.name;
      dealer.cityId = this.selectedCity.id;
      dealer.uf = this.selectedCity.uf;
    } else {
      dealer.cityName = this.dealerDetails.cityName;
      dealer.cityId = this.dealerDetails.cityId;
      dealer.uf = this.dealerDetails.uf;
    }

    dealer.cpfCnpj = this.stringToNumber(this.form.controls.cpfCnpj.value);

    dealer.id = this.dealerDetails.id || null;
    dealer.inactive = this.dealerDetails.inactive;
    dealer.hasCNAE4511 = this.dealerDetails.hasCNAE4511;

    dealer.maritalStatus = this.getMaritalStatusKey();
    if (this.dealerDetails.privateAuthorizedByOemDealers) {
      dealer.privateAuthorizedByOemDealerIds = this.dealerDetails.privateAuthorizedByOemDealers.map(o => o.id);
    }

    dealer.phoneNumbers = [this.form.controls.phoneNumber.value];
    dealer.birthDate = moment(this.form.controls.birthDate.value, "DD/MM/YYYY").toDate();
    return dealer;
  }

  submit(): void {
    this.markFormGroupTouched(this.form);
    if (!this.form.valid) {
      this.toaster.error("Verifique os campos.");
      return;
    }

    if ((!this.selectedCity && !this.form.controls.city.value) && this.layoutVars && !this.layoutVars.noAllowSensitiveData) {
      this.toaster.error("Cidade não selecionada.");
      return;
    }

    if (!this.dealerDetails.segmentClassification) {
      this.toaster.error("Escolha pelo menos um segmento");
      return;
    }

    const dealer: DealerDetails = this.prepareDealerToSave();
    dealer.segmentClassification = this.dealerDetails.segmentClassification;
    this.openService.createDealer(dealer).subscribe(
      (resp) => {
        if (resp.success) {
          this.toaster.success("Cadastro criado com sucesso.");
          this.createdSuccessfuly = true;
        } else {
          this.showError = true;
          this.errorCode = resp.errorCode;
        }
      },
      (err) => {
        console.error(err);
        this.toaster.error("Ocorreu um erro ao criar o cadastro. Procure o suporte.");
      }
    );
  }

  resetCpfCpnj() {
    this.form.controls.cpfCnpj.setValue("");
  }

  get type(): string {
    return this.form.value ? this.form.value.type : undefined;
  }

  checkEmail() {
    const email = this.form.value.email;
    this.openService.checkNewDealerEmail(email)
      .subscribe(resp => {
        if (!resp.success) {
          this.showError = true;
          this.errorCode = 'DUPLICATED_EMAIL';
        } else {
          this.showError = false;
        }
      })
  }

  getErrorMessage() {
    if (!this.form) {
      return "campo inválido";
    }
    if (this.form.controls.type.value == "PERSON") {
      return "CPF inválido.";
    } else {
      return "CPNJ inválido.";
    }
  }

  checkCpfCnpj() {
    const cpfCnpj = this.stringToNumber(this.form.controls.cpfCnpj.value);
    this.openService.checkNewDealerCpfCnpj(cpfCnpj)
      .subscribe(resp => {
        if (!resp.success) {
          this.showError = true;
          this.errorCode = 'DUPLICATED_CPF_CNPJ';
        } else {
          this.showError = false;
        }
      })
  }

  getCEP() {
    var cep = this.form.value.zipCode;
    let viaCep: ViaCep;
    if (
      cep === undefined ||
      cep.trim() === "" ||
      cep.trim().replace("-", "").length < 8
    ) {
      return;
    }

    this.applicationService
      .getCepByCreateDealer(cep.trim().replace("-", "")).subscribe((response: ViaCep) => {
        // update form
        this.form.patchValue({
          address: response.logradouro,
          district: response.bairro
        });

        this.openService.searchCitiesByName(response.localidade).subscribe(cityOptions => {
          const city = cityOptions.find(c => c.name === response.localidade && c.uf === response.uf);
          if (city) {
            this.selectCity(city);
          }
        });
      });
  }

  selectCity(city: City) {
    this.cityControl.setValue(city.name + " - " + city.uf);
    this.selectedCity = city;
  }

  onChangeCityQuery(value: string | City) {
    if (typeof value !== "string") {
      this.cityControl.setValue(value.name + " - " + value.uf);
    } else {
      this.cityOptions = this.openService.searchCitiesByName(value);
    }
  }

  toggleSegment(segment: string): void {
    if (!this.dealerDetails.segmentClassification) {
      this.dealerDetails.segmentClassification = [];
    }

    const segmentIdx = this.dealerDetails.segmentClassification.indexOf(segment);
    if (segmentIdx < 0) {
      this.dealerDetails.segmentClassification.push(segment);
    } else {
      this.dealerDetails.segmentClassification.splice(segmentIdx, 1);
    }
  }

  isSegmentSelected(segment: string): boolean {
    return this.dealerDetails.segmentClassification && this.dealerDetails.segmentClassification.indexOf(segment) >= 0;
  }

  getSegmentLabel(segment: string): SegmentLabel {
    return SegmentLabel.getSegment(segment);
  }

  get maritalStatuses(): MaritalStatus[] {
    return Object.values(MaritalStatus);
  }

  changeWhatsappOptinStatus(change: MatSlideToggleChange): void {
    this.dealerDetails.whatsappOptin = change.checked;
  }

  changeWhatsappOptinStatusCheck(change: MatCheckboxChange): void {
    this.dealerDetails.noReceiveOffers = change.checked;
  }

  getOptions(): void {
    let response = [];
    if (this.layoutVars) {
      for (let option of this.layoutVars.allowedRegisterType) {
        response.push(new IdName(option, option == 'COMPANY' ? 'Pessoa Jurídica' : 'Pessoa Física'));
      }
    }else{
      response.push(new IdName('COMPANY', 'Pessoa Jurídica'));
      // response.push(new IdName('PERSON', 'Pessoa Física'));
    }

    this.options = response;

    if(response.length == 1){
      this.form.controls.type.setValue(response[0].id)
    }
  }

  get noAllowSensitiveData(){
    return this.layoutVars && this.layoutVars.noAllowSensitiveData;
  }
}
